import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataService } from '../data.service';
import * as XLSX from 'xlsx';
import { ActivatedRoute } from '@angular/router';
interface UploadEvent {
  originalEvent: Event;
  files: File[];
}

@Component({
  selector: 'app-form-precargar',
  templateUrl: './form-precargar.component.html',
  styleUrls: ['./form-precargar.component.css']
})
export class FormPrecargarComponent {
  uploadedFileName: string = '';
  uploadedFiles: any[] = [];

 opcionSeleccionada: any = null;
    // Método que se ejecuta cuando se selecciona un archivo
    constructor(public data: DataService, private route: ActivatedRoute, private messageService: MessageService) {

      this.data.encuestaSeleccionada$.subscribe(valor => {
        this.opcionSeleccionada = valor ?? '';
      });


    }

    onFileSelect(event: any) {
      this.messageService.add({severity:'info', summary: 'Información', detail: 'Archivo seleccionado'});
      this.uploadedFileName = event.files[0].name;
    }
  
    // Método para subir el archivo manualmente al servidor
    uploadFiles(event: any) { 

      const selectedFile = event.files[0];
      const fileR = new FileReader();
      fileR.readAsBinaryString(selectedFile);
      fileR.onload = (event) => {
          console.log(event);
          let binaryData = event.target.result;
          let archivo = XLSX.read(binaryData, { type: 'binary' });
          console.log(archivo);

          const sujetos = XLSX.utils.sheet_to_json(archivo.Sheets['Registros']);
          const colecciones = XLSX.utils.sheet_to_json(archivo.Sheets['Colecciones']);
          console.log(sujetos);
          //alert("Precargue para encuesta: " + JSON.stringify(this.opcionSeleccionada));

          this.data.Precargue(this.opcionSeleccionada, sujetos, colecciones).subscribe(x => {
              this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Registros enviados satisfactoriamente'});


          })
      }
    }

    onUpload(event:UploadEvent) {
      for(let file of event.files) {
          this.uploadedFiles.push(file);
      }

      this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
    }

    async descargarPlantilla() {
      // Crear una hoja de cálculo con las cabeceras

      var campos: string[] = await this.ObtenerCampos();

      //insertar al principio de campos $CorreoResponsable,	$FechaInicio,	$FechaFin,	$$Correo
      
      // campos.unshift("$FechaFin");
      // campos.unshift("$FechaInicio");
      // campos.unshift("$CorreoResponsable");


      const worksheet = XLSX.utils.aoa_to_sheet([campos]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Registros");
  
      // Escribir el archivo Excel y descargarlo
      XLSX.writeFile(workbook, "Plantilla_Registros.xlsx");
  }

  async ObtenerCampos (): Promise<string[]>{
    return new Promise((resolve, reject) => {
    var campos=[];
    this.data.ObtenerCampos(this.opcionSeleccionada).subscribe(
      {
        next: (x) => {      
          var registros = x.registros;
          //recorrer registros para obtener los campos
          registros.forEach(element => {
            campos.push(element.elementName);
          });     
          resolve(campos);    
        },
        error: (error) => {
          // Si error es 404, no hay registros 
          if (error.status === 404) {
            console.log('No hay registros');
            //this.hayRegistros = false;
          } else {
            console.error('Error al listar registros:', error);
          }
        }
      }
    );
    });
  }

}
